import { ProjectCommentModel } from "../models/ProjectCommentModel";
import API from "./API";

const ProjectCommentService = {
  async getAllProjectComments() {
    const response = await API().get("ProjectComment", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularProjectComment(ProjectComment_id: number) {
    const response = await API().get("ProjectComment");
    return response.data.filter(
      (cur_ProjectComment: ProjectCommentModel) =>
        cur_ProjectComment.projectCommentId === ProjectComment_id
    )[0];
  },
  async getParticularProjectAllComments(Project_id: number) {
    const response = await API().get(
      "ProjectComment/GetProjectCommentsByProjectId/" + Project_id,
      {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  },
  async setParticularProjectParticularComment(
    projectComment: ProjectCommentModel
  ) {
    const response = await API().post("ProjectComment", projectComment, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
};

export default ProjectCommentService;
